import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/closet-organization-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>A Guide to Organizing Your Poshmark Closet</title>
        <meta
          name='description'
          content='A closet is a place where we can all be organized and tidy. But for us who sells on Poshmark, going through our storage and sorting all clothing into the piles can be a bit overwhelming.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/closet-organization-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/closet-organization-poshmark' />
        <meta property='og:title' content='A Guide to Organizing Your Poshmark Closet' />
        <meta
          property='og:description'
          content='A closet is a place where we can all be organized and tidy. But for us who sells on Poshmark, going through our storage and sorting all clothing into the piles can be a bit overwhelming.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
